// Copyright (c) 2024 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

export enum LocalStorageSplitPaneKey {
    TransactionView = 'splitPanes/transaction-view',
    AddressViewHorizontal = 'splitPanes/address-view-horizontal',
    AddressViewVertical = 'splitPanes/address-view-vertical',
}
